import axiosWrapper from "@Services/axiosWrapper";
import { getBackendUrl } from "@Utils";
import { setUserTagLoading, setUserTagData, setUpdatedUserProfileDetails } from "../reducers/userTagData";

export const fetchUserTagData = (id) => async (dispatch, getState) => {
  const { userTagData } = getState();

  if (userTagData[id]?.isLoading || userTagData[id]?.isLoaded) {
    return;
  }

  dispatch(setUserTagLoading({ id }));

  try {
    // Fetch user details
    const response = await getUserDetailsById({ userId: id });
    let profilePic = null;

    // If there's a profile picture to fetch, get the image as a blob
    if (response.data?.data.profilePic) {
      const imgResponse = await axiosWrapper.get(
        `${process.env.REACT_APP_CUBE_BACKEND}/fileSystemServer/getImage/profile/${id}`,
        { responseType: "blob" },
      );

      // Use FileReader to convert blob to Base64
      const reader = new FileReader();

      reader.onloadend = function () {
        // The result of reader is a Base64 string
        profilePic = reader.result;

        // Dispatch the data with the Base64 image URL
        dispatch(setUserTagData({ id, data: { ...(response.data?.data || {}), profilePic } }));
      };

      // Read the Blob as Data URL
      reader.readAsDataURL(imgResponse.data);
    } else {
      // If there's no profile picture, just dispatch the data without it
      dispatch(setUserTagData({ id, data: { ...(response.data?.data || {}), profilePic } }));
    }
  } catch (error) {
    console.error("Error fetching user tag data:", error);
  }
};

export const updateUserProfileDetails = (data) => (dispatch) => {
  if (data) {
    dispatch(setUpdatedUserProfileDetails(data));
  }
};

export async function getUserDetailsById(data) {
  return await axiosWrapper.post(`${getBackendUrl()}/accounts/getUserDetailsById`, data);
}
